import React from "react";
import ChevronsRightIcon from "../../../../shared-components/icons/ChevronsRightIcon";

const OtherCompButton = () => {
  return (
    <button
      onClick={() => (location.href = "/")}
      className="theme-btn theme-btn-primary-outline theme-btn-lg lg:theme-btn-2xl text-primary uppercase w-full">
      CHECK OTHER COMPETITIONS
      <ChevronsRightIcon variant={3} className={"size-4 lg:size-5 shrink-0"} />
    </button>
  );
};

export default OtherCompButton;
